import { Directive, Input, inject } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';

@Directive(
    {
        selector: '[tnbAvailableStadtwerkeId]',
        providers: [
            {
                provide: NG_ASYNC_VALIDATORS,
                useExisting: AvailableStadtwerkeIdDirective,
                multi: true,
            },
        ],
        standalone: false,
    },
)
export class AvailableStadtwerkeIdDirective implements Validator {
    private netzbetreiberService = inject(NetzbetreiberService);

    // if set to false, do not perform validation
    @Input() tnbAvailableStadtwerkeId = true;

    validate(stadtwerkeId: AbstractControl): Observable<ValidationErrors | null> | ValidationErrors {
        {
            if (!stadtwerkeId.value || !this.tnbAvailableStadtwerkeId) {
                return of(null);
            }
            return this.netzbetreiberService.isStadtwerkeIdAvailable(stadtwerkeId.value)
                .pipe(
                    map(available => {
                        return (!available)
                            ? { 'availableStadtwerkeId': true }
                            : null;
                    }),
                );
        }
    }

}
